import React from 'react';
import { ImageIcon } from 'lucide-react';
import type { SiteImage } from '../data/collection';
interface AssetImageProps {
  image: SiteImage;
  className?: string;
  fit?: 'contain' | 'cover';
  priority?: boolean;
  /** Smaller placeholder text for tiny slots (hero mockup, thumbnails). */
  compact?: boolean;
  /** Use the lighter thumbnail file when one is available. */
  thumb?: boolean;
}

/**
 * Renders a real page/cover, or — until its URL is set — a prepared paper
 * frame labelled with the image's descriptive file name.
 */
export function AssetImage({
  image,
  className = '',
  fit = 'contain',
  priority = false,
  compact = false,
  thumb = false
}: AssetImageProps) {
  if (!image.src) {
    return <div role="img" aria-label={image.alt} className={`relative flex h-full w-full flex-col items-center justify-center gap-1.5 bg-paper text-center ${compact ? 'p-2' : 'p-4'} ${className}`} data-id="element-28" data-mp="1q4d4kln194io">
        <span aria-hidden className="pointer-events-none absolute inset-[5%] rounded-[4px] border border-dashed border-coral/40" data-id="element-29" data-mp="1z405l6buo8b7" />
        <ImageIcon className={`${compact ? 'h-3.5 w-3.5' : 'h-5 w-5'} text-coral/70`} aria-hidden data-id="element-30" data-mp="2zi5mmsvvnjga" />
        {!compact && <span className="max-w-[85%] break-all font-mono text-[10px] leading-snug text-graphite-soft sm:text-[11px]" data-id="element-31" data-mp="2ulycsp0d1nt2">
            {image.file}
          </span>}
      </div>;
  }
  return <img src={thumb && image.thumbSrc ? image.thumbSrc : image.src} alt={image.alt} width={image.width} height={image.height} loading={priority ? 'eager' : 'lazy'} decoding="async" draggable={false} className={`h-full w-full ${fit === 'contain' ? 'object-contain' : 'object-cover object-top'} ${className}`} data-id="element-32" data-mp="3nam0sschurab" />;
}